const globalStateKey = '__persist-promise:GlobalState';

const fallback = { [globalStateKey]: {} };

type Container = { [key: string]: any };

type Storage = { [globalStateKey]: Container };

const getGlobalStorage = (
  storage: Storage = window as unknown as Storage
): Container => {
  try {
    if (!storage[globalStateKey]) {
      storage[globalStateKey] = {};
    }

    return storage[globalStateKey];
  } catch (e) {
    // Fall back to storing in module
    return fallback[globalStateKey];
  }
};

export const getGlobal = <TResult>(key: string) =>
  getGlobalStorage()[key] as TResult | undefined;

export const hasGlobal = (key: string) => {
  const global = getGlobalStorage();

  return global && global[key] !== undefined;
};

export const setGlobal = (key: string, value: any) => {
  const global = getGlobalStorage();

  if (global) {
    global[key] = value;
  }
};

export const __TEST_ONLY__clearGlobal = () => {
  const global = getGlobalStorage();

  Object.keys(global).forEach((key) => {
    delete global[key];
  });
};
